/**
 * Frontend reCAPTCHA Service
 * Handles reCAPTCHA configuration using environment variables
 */

interface RecaptchaConfig {
  siteKey: string;
  version: string;
  enabled: boolean;
}

class RecaptchaService {
  private static instance: RecaptchaService;
  private config: RecaptchaConfig | null = null;

  private constructor() {}

  public static getInstance(): RecaptchaService {
    if (!RecaptchaService.instance) {
      RecaptchaService.instance = new RecaptchaService();
    }
    return RecaptchaService.instance;
  }

  /**
   * Get reCAPTCHA configuration from environment variables
   */
  public getConfig(): RecaptchaConfig {
    // Return cached config if available
    if (this.config) {
      return this.config;
    }

    // Load from environment variable with fallback
    const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6LfyedcrAAAAAOOgkkqtbkgz7rVlDcj6AFFClzOL';
    
    this.config = {
      siteKey,
      version: 'v2',
      enabled: true,
    };

    console.log('reCAPTCHA configured with site key:', siteKey);
    return this.config;
  }

  /**
   * Get site key for reCAPTCHA widget
   */
  public getSiteKey(): string {
    const config = this.getConfig();
    return config.siteKey;
  }

  /**
   * Check if reCAPTCHA is enabled
   */
  public isEnabled(): boolean {
    const config = this.getConfig();
    return config.enabled;
  }

  /**
   * Get reCAPTCHA version
   */
  public getVersion(): string {
    const config = this.getConfig();
    return config.version;
  }

  /**
   * Clear cached configuration (useful for testing or config updates)
   */
  public clearCache(): void {
    this.config = null;
  }

  /**
   * Note: reCAPTCHA token validation is handled on the backend
   * during form submission. No separate validation API call needed.
   */
}

export const recaptchaService = RecaptchaService.getInstance();
export default recaptchaService;